import { render, staticRenderFns } from "./orderDriverTabs.vue?vue&type=template&id=38a24606"
import script from "./orderDriverTabs.vue?vue&type=script&lang=js"
export * from "./orderDriverTabs.vue?vue&type=script&lang=js"
import style0 from "./orderDriverTabs.vue?vue&type=style&index=0&id=38a24606&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports